import { render, staticRenderFns } from "./ListGoodsItem.vue?vue&type=template&id=6bc0e04f&"
import script from "./ListGoodsItem.vue?vue&type=script&lang=js&"
export * from "./ListGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./ListGoodsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports